import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cozy%20reading%20atmosphere%2C%20warm%20ambient%20lighting%2C%20soft%20golden%20hour%20glow%2C%20comfortable%20reading%20nook%20with%20warm%20tones%2C%20relaxing%20vibes%2C%20Korean%20digital%20art%20style%2C%20rich%20amber%20and%20cream%20color%20palette&width=1800&height=900&seq=cta-bg-reading-2026&orientation=landscape"
        alt="立即开始阅读韩漫"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white tracking-wide mb-4">
          开启你的韩漫之旅
        </h2>
        <p className="text-white/70 text-sm md:text-base max-w-md mb-8">
          免费韩漫大全，无删减高清画质，下拉式流畅阅读
          <br />随时随地，畅享优质韩漫
        </p>
        <Link
          to="/category/dong-zuo"
          className="group inline-flex items-center gap-3 px-8 py-3.5 bg-foreground-950 hover:bg-foreground-900 text-white rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center">
            <i className="ri-book-open-line text-white text-xs"></i>
          </span>
          立即阅读
          <i className="ri-arrow-right-up-line transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
        </Link>
      </div>
    </section>
  );
}